// default
export const COMPANY = 'company';
export const COMPANY_SLICE_NAME = `${COMPANY}Slice`;

// action
export const GET_COMPANY_LIST = `${COMPANY}/GET_COMPANY_LIST`;
export const GET_COMPANY_DETAIL = `${COMPANY}/GET_COMPANY_DETAIL`;

// actions
export const actions = {
  GET_COMPANY_LIST,
  GET_COMPANY_DETAIL
};
